import { FC, MouseEvent, KeyboardEvent } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { cn } from 'src/utils/utility';

interface CardMetricEditProps {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export const CardMetricEdit: FC<CardMetricEditProps> = ({ onClick, className }) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
    // Trigger click on Enter or Space key
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.(event as any); // Cast needed due to event type difference
    }
  };

  return (
    <button
      type='button'
      className={cn(
        'relative overflow-hidden bg-white border border-neutral-20 rounded-8 shadow-sm w-[78px] h-[94px] flex flex-col items-center justify-center gap-4 cursor-pointer hover:bg-neutral-10 transition-colors focus:outline-none',
        className
      )}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      aria-label='Edit metrics selection'
    >
      <span className='text-sm text-neutral-90 font-medium'>Metrics</span>
      <EditIcon className='text-neutral-50' fontSize='small' />
    </button>
  );
};
